import React from 'react';
import MapboxGL from 'mapbox-gl';

import FormMap from 'components/FormMap/FormMap';
import * as FiltersValue from 'helpers/mapFiltersHelpers';
import { getFilters } from 'helpers/activityHelpers';
import { addTooltipProperties } from 'helpers/featuresHelpers';
import { showTooltipOverFeature } from 'helpers/mapHelpers';

const localPopup = new MapboxGL.Popup({
  anchor: 'bottom',
  offset: 5,
  closeButton: false,
  closeOnClick: false,
});

export const Map = ({ geojsonConflicts, data, activity, activityTypes }) => (
  <React.Fragment>
    <h3>Lieu de l&apos;activité</h3>
    <div
      style={{ overflow: 'hidden', width: 0, height: 0 }}
      className="vanilla-map"
    >
      <div style={{ width: 800 }}>
        <FormMap
          geojsonConflicts={{
            ...geojsonConflicts,
            features: geojsonConflicts.features.filter(feat =>
              feat.properties.activity === activity.uid),
          }}
          activityFilters={getFilters(activity.type, activityTypes)}
          features={addTooltipProperties(data.geojson.features)}
          activity={activity}
          FiltersValue={FiltersValue}
          activityDates={activity.eventDates}
          onlyMap
        />
      </div>
    </div>

    {/* Ce second formMap permet de créer un screen de la carte pour les exports */}
    <FormMap
      geojsonConflicts={{
        ...geojsonConflicts,
        features: geojsonConflicts.features.filter(feat =>
          feat.properties.activity === activity.uid),
      }}
      mapProps={{
        onMouseMove: showTooltipOverFeature(localPopup),
      }}
      activityFilters={getFilters(activity.type, activityTypes)}
      features={addTooltipProperties(data.geojson.features)}
      activity={activity}
      editable={false}
      FiltersValue={FiltersValue}
      activityDates={activity.eventDates}
    />
  </React.Fragment>
);

export default Map;



// WEBPACK FOOTER //
// ./src/components/Summary/Controls/ControlMap.js